import { Injectable } from '@angular/core';

@Injectable()
export class Global {
    role: string = 'test';
    apiBaseURl:string = '';
    
}
